export const USER_ROLE_IDS = {
  ADMINISTRATOR: 'bdfe412a-dbaa-4997-b1c5-352f15e114ce',
  DATA_MANAGER: '31d0fa67-1170-4455-8eb8-08d8a462ffb6',
  GUEST: '97497d79-097f-4463-8442-0f7f73fa69e5',
  PEOPLE_MANAGER: '8b0f63dd-bfaf-4fec-ab93-37225684b4b5',
  SUPER_ADMIN: '7c848183-fa72-4a09-835a-ec0ac2af5658'
} as const;
